import React from "react";
import { object, string } from "prop-types";
// eslint-disable-next-line import/no-cycle
import { Button } from "../Button";
import { Modal } from "./Modal";
// eslint-disable-next-line import/no-cycle
import { FluidSections } from "../FluidSections";
import { Img, Icon } from "../../sharedComponents/Images";
import * as styles from "./FluidModal.module.scss";

const renderTrigger = (component, fields) => {
	let returnComponent = null;

	switch (component) {
		case "button":
			return (
				<Button
					buttonType={fields.variant}
					icon={fields.iconName}
					outline={fields.invertButtonStyle}>
					{fields.text && fields.text}
				</Button>
			);
		case "link":
			return (
				// eslint-disable-next-line jsx-a11y/anchor-is-valid
				<a
					href="#"
					onClick={e => {
						e.preventDefault();
					}}>
					{fields.linkText}
				</a>
			);

		case "icon":
			if (fields?.fontAwesomeIcon) {
				returnComponent = (
					<Icon
						icon={{
							fontAwesome: {
								type: fields.fontAwesomeIcon.type,
								name: fields.fontAwesomeIcon.name,
							},
						}}
					/>
				);
			} else if (fields?.svg) {
				returnComponent = (
					<Img
						title={fields.img.title}
						alt={fields.img.title}
						fluid={fields.img.fluid}
						className={styles.img}
					/>
				);
			}

			return returnComponent;
		default:
			return <></>;
	}
};
const FluidModal = ({ data, locale }) => (
	<Modal contentLabel="content details">
		<Modal.Trigger style={{ display: "inline", width: "auto" }}>
			{renderTrigger(data?.trigger?.sys?.contentType?.sys?.id, data?.trigger)}
		</Modal.Trigger>
		<Modal.Content>
			<FluidSections data={data?.content} useWrapper={false} locale={locale} />
		</Modal.Content>
	</Modal>
);

FluidModal.propTypes = {
	data: object.isRequired,
	locale: string.isRequired,
};

export default FluidModal;
export { FluidModal };
